// extracted by mini-css-extract-plugin
module.exports = {"container":"Auth-container-1IDZh","core":"Auth-core-3G6js","img":"Auth-img-23o_4","form":"Auth-form-3Z_zk","content":"Auth-content-2pmoq"};